var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveDeclineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "none",
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#306EA9",
    d: "M29.965 18.27a1.042 1.042 0 0 1-2.084 0V14.1a1.042 1.042 0 0 1 2.084 0v4.17ZM27.186 18.386v-3.774a1.39 1.39 0 0 0-.768-1.243l-.035-.017a2.78 2.78 0 0 0-1.243-.293h-3.764a1.39 1.39 0 0 0-1.362 1.117l-.834 4.169a1.39 1.39 0 0 0 1.363 1.662h2.474v2.78c0 .767.622 1.39 1.39 1.39a.695.695 0 0 0 .694-.695v-.463c0-.602.195-1.187.556-1.668l.973-1.297a2.78 2.78 0 0 0 .556-1.668ZM8.035 23.73a1.042 1.042 0 0 1 2.085 0v4.169a1.042 1.042 0 1 1-2.085 0v-4.17ZM10.815 23.614v3.773c0 .527.297 1.008.768 1.243l.034.018a2.78 2.78 0 0 0 1.244.293h3.763a1.39 1.39 0 0 0 1.363-1.117l.834-4.17a1.39 1.39 0 0 0-1.363-1.662h-2.474v-2.78a1.39 1.39 0 0 0-1.39-1.389.695.695 0 0 0-.695.695v.463a2.78 2.78 0 0 1-.556 1.668l-.972 1.297a2.78 2.78 0 0 0-.556 1.668Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    rx: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveDeclineIcon);
export default __webpack_public_path__ + "static/media/approve-decline-icon.76999618950fbdbdf634f0273c561a41.svg";
export { ForwardRef as ReactComponent };